import { reactive, ref } from 'vue';
import { defineStore } from 'pinia';

interface LayoutConfig {
  preset: string;
  primary: string;
  surface: string;
  darkTheme: boolean | null;
  menuMode: string;
  scale: number;
  activeMenuItem: string | null;
  tableSize: 'small' | 'normal' | 'large';
  theme: 'system' | 'dark' | 'light';
}

interface LayoutState {
  staticMenuDesktopInactive: boolean;
  overlayMenuActive: boolean;
  profileSidebarVisible: boolean;
  configSidebarVisible: boolean;
  staticMenuMobileActive: boolean;
  menuHoverActive: boolean;
  activeMenuItem: string;
}

export const useLayoutStore = defineStore('layout', () => {
  const layoutConfig = ref<LayoutConfig>({
    preset: 'Aura',
    primary: 'emerald',
    surface: 'slate',
    darkTheme: null,
    menuMode: 'static',
    scale: 14,
    activeMenuItem: null,
    tableSize: 'normal',
    theme: 'system',
  });

  const layoutState = ref<LayoutState>({
    staticMenuDesktopInactive: false,
    overlayMenuActive: false,
    profileSidebarVisible: false,
    configSidebarVisible: false,
    staticMenuMobileActive: false,
    menuHoverActive: false,
    activeMenuItem: '',
  });

  return {
    layoutConfig,
    layoutState,
  };
}, {
  persist: true,
});
